<template>
  <draggable
    :id="`draggable-level-${level}`"
    class="text-left drag-area"
    tag="ul"
    :list="items"
    :group="{ name: 'elements' }"
    :scrollSensitivity="200"
    :move="onMove"
    v-on="$listeners"
  >
    <li
      v-for="(element, idx) in items"
      :key="`${parentKey}-${idx}`"
      :class="element[childItemsKey] ? classesGroup : classesElement"
    >
      <slot
        name="listElement"
        v-bind="{
          ...element,
          level,
          parentKey,
          elementKey: `${parentKey}-${idx}`,
          dotsItems: element.dotsItems || (element[childItemsKey] ? groupsDotsItems : elementsDotsItems) || [],
          disabled,
        }"
      >
        <draggable-list-item
          v-bind="{
            ...element,
            level,
            parentKey,
            elementKey: `${parentKey}-${idx}`,
            dotsItems: element.dotsItems || (element[childItemsKey] ? groupsDotsItems : elementsDotsItems) || [],
            disabled,
            titleKey: itemTitleKey,
            childItemsKey: childItemsKey,
          }"
          v-on="$listeners"
        />
      </slot>
      <draggable-list-draggable
        v-if="element[childItemsKey]"
        :items="element[childItemsKey]"
        :allow-elements-on-main-level="allowElementsOnMainLevel"
        :allow-nested-groups="allowNestedGroups"
        :disabled="disabled"
        :elements-dots-items="elementsDotsItems"
        :groups-dots-items="groupsDotsItems"
        :item-title-key="itemTitleKey"
        :level="level + 1"
        :parent-key="`${parentKey}-${idx}`"
        :child-items-key="childItemsKey"
        v-on="$listeners"
      >
        <template v-for="(value, key) in $scopedSlots" #[key]="scope">
          <slot :name="key" v-bind="scope" />
        </template>
      </draggable-list-draggable>
    </li>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable-multi';
import DraggableListItem from '@/components/DraggableListItem';
export default {
  name: 'DraggableListDraggable',
  components: { draggable, DraggableListItem },
  props: {
    allowElementsOnMainLevel: {
      type: Boolean,
      default: false,
    },
    allowNestedGroups: {
      type: Boolean,
      default: false,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    elementsDotsItems: {
      type: Array,
    },
    groupsDotsItems: {
      type: Array,
    },
    itemTitleKey: {
      type: String,
      default: 'name',
    },
    level: {
      type: Number,
      default: 1,
    },
    parentKey: {
      type: [String, Number],
      default: '0',
    },
  },
  computed: {
    classesGroup() {
      return this.level === 1 ? ['li--group', 'pb-2'] : ['margin--bottom', 'border'];
    },
    classesElement() {
      return this.level === 1 ? ['li--element'] : ['margin--bottom', 'border'];
    },
  },
  methods: {
    onMove(e) {
      if (!this.allowNestedGroups && e.draggedContext.element[this.childItemsKey] && e.to.id !== 'draggable-level-1') {
        return false;
      }
      if (
        !this.allowElementsOnMainLevel &&
        !e.draggedContext.element[this.childItemsKey] &&
        e.to.id === 'draggable-level-1'
      ) {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0;
}
.margin--bottom {
  &:not(:last-child) {
    margin-bottom: 4px;
  }
}
.li--group {
  padding: 0 24px;
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
.li--element {
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
.drag-area {
  min-height: 25px;
}
</style>
